// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2YLJ_","notes":"Notes_notes__1MNkt","note":"Notes_note__EPKkm","markdown":"Notes_markdown__tUVUU"};